import { makeAutoObservable } from 'mobx';
import { IAppStore } from '../../Pages/store';

export interface IPatientsServiceStore {
  readonly queryKey: (string | Record<string, string>)[];
}

export class PatientsServiceStore implements IPatientsServiceStore {
  appStore: IAppStore;
  constructor(appStore: IAppStore) {
    makeAutoObservable(this);
    this.appStore = appStore;
  }

  get queryKey() {
    return ['camel', 'patients', { clinicUuid: this.appStore.clinicUuid }];
  }
}
